import { Box, Typography } from "@mui/material";

export const BranchInfo = () => {
    const tagName = process.env.REACT_APP_TAG_NAME;
    const commitHash = process.env.REACT_APP_COMMIT_HASH;
    const branchName = process.env.REACT_APP_BRANCH_NAME;

    const displayValue = tagName || commitHash?.slice(0, 7) || branchName;

    if (!displayValue) {
        return null;
    }

    return (
        <Box sx={{ width: "100%", textAlign: "center", py: 1 }}>
            <Typography variant="caption" color="textSecondary">
                {displayValue}
            </Typography>
        </Box>
    );
};
